import { useTheme } from '@hover/blueprint';
import type { SystemProps } from '@hover/blueprint';
import type { MotionValue } from 'framer-motion';
import { useMotionTemplate } from 'framer-motion';

import { useCurrentPage } from 'src/shared/hooks';
import type { CurrentPage } from 'src/shared/hooks/useSegmentHistory';
import { Route } from 'src/shared/route';

export const desktopNavbarHeight = 90;
export const mobileNavbarHeight = 50;

export const navbarGlassBlur = 20;
export const navbarGlassOpacity = 1;

export const MOBILE_NAVBAR_WIDTH = 165;

export const navbarGlass = {
  background: `rgba(255, 255, 255, ${navbarGlassOpacity})`,
  backdropFilter: `blur(${navbarGlassBlur}px)`,
} satisfies SystemProps;

export const useNavbarGlass = (
  opacity: MotionValue<number>,
  blur: MotionValue<number>,
) => ({
  backgroundColor: useMotionTemplate`rgba(255, 255, 255, ${opacity})`,
  backdropFilter: useMotionTemplate`blur(${blur}px)`,
});

const getOpacity = (page: CurrentPage, loggedIn: boolean) => {
  switch (page) {
    case Route.HOMEOWNER_APP_HOME.page:
      return loggedIn ? 0.4 : 0.6;
    case Route.HOMEOWNER_APP_SAVED.page:
      return loggedIn ? 0.4 : 0.9;
    default:
      return 0.4;
  }
};

export const useMobileNavbarStyle = ({
  isGlass = false,
  loggedIn = false,
}: {
  isGlass?: boolean;
  loggedIn?: boolean;
}) => {
  const { colors } = useTheme();
  const page = useCurrentPage();

  return {
    backgroundColor: isGlass
      ? `${colors.alpha(getOpacity(page, loggedIn), 'neutral.900')} !important`
      : 'neutral.700 !important',
    backdropFilter: 'blur(20px) !important',
  };
};
